(() => {
  function publishWaisaIntent(name, params = {}) {
    if (!name) return;
    const payload = { ...params };
    try {
      window.Shopify?.analytics?.publish?.(name, payload);
    } catch {
      // Ignore theme analytics hosts that reject unknown custom events.
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  }

  window.__waisaPublishIntent = publishWaisaIntent;

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      // Geolocation CTAs publish their own find_store event.
      if (target?.closest('[data-find-nearest-store]')) return;
      const explicitIntent = target?.closest('[data-waisa-intent]');
      const el = explicitIntent || target?.closest('a[href]');
      if (!el) return;
      let name = el.getAttribute('data-waisa-intent');
      if (!explicitIntent) {
        try {
          const url = new URL(el.getAttribute('href'), window.location.origin);
          if (
            url.origin !== window.location.origin ||
            url.pathname.replace(/\/$/, '') !== '/pages/find-waisa'
          ) {
            return;
          }
          name = 'find_store';
        } catch {
          return;
        }
      }
      if (!name) return;
      const storeName = el.getAttribute('data-store-name');
      publishWaisaIntent(name, {
        ...(storeName ? { store_name: storeName } : {}),
        link_url: el.getAttribute('href') || undefined,
      });
    },
    true
  );
})();
